module.exports = __webpack_public_path__ + "img/btn3-2.9d1145e4.png";